import { useTranslation } from 'react-i18next';

export type FormatType = 'bold' | 'italic' | 'underline' | 'bulletList' | 'numberedList';

interface EditorToolbarProps {
  onFormat: (type: FormatType) => void;
  isPreviewMode: boolean;
  onTogglePreview: () => void;
  isReadOnly?: boolean;
}

export default function EditorToolbar({
  onFormat,
  isPreviewMode,
  onTogglePreview,
  isReadOnly = false,
}: EditorToolbarProps) {
  const { t } = useTranslation();
  const isDisabled = isReadOnly || isPreviewMode;

  return (
    <div className={`editor-toolbar ${isReadOnly ? 'read-only' : ''}`}>
      <div className="toolbar-group">
        <button
          type="button"
          className="toolbar-btn"
          title={t('editorToolbar.bold')}
          disabled={isDisabled}
          onClick={() => onFormat('bold')}
        >
          <strong>B</strong>
        </button>
        <button
          type="button"
          className="toolbar-btn"
          title={t('editorToolbar.italic')}
          disabled={isDisabled}
          onClick={() => onFormat('italic')}
        >
          <em>I</em>
        </button>
        <button
          type="button"
          className="toolbar-btn"
          title={t('editorToolbar.underline')}
          disabled={isDisabled}
          onClick={() => onFormat('underline')}
        >
          <span style={{ textDecoration: 'underline' }}>U</span>
        </button>
      </div>

      <div className="toolbar-divider" />

      <div className="toolbar-group">
        <button
          type="button"
          className="toolbar-btn"
          title={t('editorToolbar.bulletList')}
          disabled={isDisabled}
          onClick={() => onFormat('bulletList')}
        >
          {t('editorToolbar.bulletListLabel')}
        </button>
        <button
          type="button"
          className="toolbar-btn"
          title={t('editorToolbar.numberedList')}
          disabled={isDisabled}
          onClick={() => onFormat('numberedList')}
        >
          {t('editorToolbar.numberedListLabel')}
        </button>
      </div>

      <div className="toolbar-spacer" />

      <div className="toolbar-group">
        <button
          type="button"
          className={`toolbar-btn preview-toggle ${isPreviewMode ? 'active' : ''}`}
          title={t('editorToolbar.togglePreview')}
          onClick={onTogglePreview}
        >
          {isPreviewMode ? t('editorToolbar.edit') : t('editorToolbar.preview')}
        </button>
      </div>

      {isReadOnly && (
        <div className="read-only-badge">{t('editorToolbar.readOnly')}</div>
      )}
    </div>
  );
}
